module App.HiLO.Services {
    'use strict';
    export class QuestionHelperService {
        public static $inject = [
			'app.common.services.globalSettingsService',
			"$sce"
        ];

        constructor(
			private _globalSettingsService: Common.Services.GlobalSettingsService) {
		};
		corporateContactEmail: string = this._globalSettingsService.emails.corporateContactEmail;
		propertyWithinEngland: IQuestionInfo = {
			text: "Is your property located within England?",
			hint: "Homes England only has responsibility for properties in England",
			error: "Homes England only has responsibility for properties in England. We will not be able to help you with this request."
		};

		propertyWithinGreaterLondon: IQuestionInfo = {
			text: "Is your property in Greater London Authority?",
			error: "Please contact the Greater London Authority on 020 7983 4000."
		};

		registeredLandRegistry: IQuestionInfo = {
			text: "Is the title of the property registered at the Land Registry?",
			error: "Please contact <a href='mailto:" + this.corporateContactEmail + "'>" + this.corporateContactEmail + "</a>"
		}
    }

	export interface IQuestionInfo{
		text: string;
		hint?: string;
		error: string | any;
	}

    angular
        .module('app.hilo.services')
        .service('app.hilo.services.questionHelperService', QuestionHelperService);
}